<template>
  <p :class="wrapperClass ? wrapperClass : ''">
    <label :class="`a-radiobutton-primary a-radiobutton-margin-right-large ${radioButtonPrimary.labelClass}`">
      <input
        :checked="shouldBeChecked"
        :disabled="disabled"
        :name="radioButtonPrimary.name"
        type="radio"
        :value="value"
        @change="updateRadio"
      />
      <span class="a-radiobutton-checkmark"></span>
      {{ text }}
      <span
        v-if="tooltip"
        class="a-tooltip-secondary a-tooltip-top margin-left-xsmall font-size-small text-color-black-35"
        :data-tooltip-text="tooltip"
      >
        <i class="fas fa-info-circle"></i>
      </span>
    </label>
  </p>
</template>

<script>
export default {
  name: 'AtomRadioButtonPrimary',

  props: {
    disabled: Boolean,
    modelValue: [Number, String],
    radioButtonPrimary: Object,
    text: String,
    tooltip: String,
    value: [Number, String],
    wrapperClass: String
  },

  model: {
    prop: 'modelValue',
    event: 'change'
  },

  computed: {
    shouldBeChecked () {
      return this.modelValue === this.value
    }
  },

  methods: {
    updateRadio () {
      this.$emit('change', this.value)
    }
  }
}
</script>
